<template>
  <v-banner two-line outlined :value="show">
    <v-avatar slot="icon" color="deep-purple accent-4" size="40">
      <v-icon icon="privacy_tip" color="white">
        privacy_tip
      </v-icon>
    </v-avatar>
    <div v-if="!hideTitle" class="text-h5">Tip!</div>
    <div class="text-body-2">
      <slot />
    </div>
    <template v-slot:actions>
      <v-btn text color="primary" @click="show = false">Dismiss</v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  name: 'TipBanner',
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: true,
  }),
}
</script>
